const SpotifyPlaylist = ({ url }) => {
        console.log('url', url)
        const embedUrl = url.replace(
            "open.spotify.com",
            "open.spotify.com/embed"
        );

        return (
            <div style={{ borderRadius: 12, overflow: "hidden" }}>
            <iframe
                src={embedUrl}
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="Clubkillers Spotify Playlist"
            />
            </div>
        );
};
export default SpotifyPlaylist;